import { css } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { heading5Obj } = typographyStyles;

export const menuChoice = css`
  margin-bottom: .4rem;
  && {
  display: flex;
  list-style-type: none;
    &&& {
      &:hover {
    background:  ${constants.colors.ui.neutral[25]};
    cursor: pointer;
  };
    &:focus {
      background: ${constants.colors.ui.neutral[25]};
    }
   }
  }
}
`;

export const selectedMenuOption = css`
  display: flex;
  margin-bottom: 0.4rem;
  background: ${constants.colors.ui.neutral[25]};
  color: ${constants.colors.ui.neutral[700]};
  list-style-type: none;
  &:focus {
    outline: 2px solid ${constants.colors.ui.core[600]};
    outline-offset: -2px;
  }
`;

export const menuOptionsContainer = css`
  font-family: ${heading5Obj.fontFamily};
  fontsize: 1rem;
  padding: 0;
  list-style-type: none;
`;

export const selectedBar = css`
  width: 0.25rem;
  background-color: ${constants.colors.ui.core[600]};
  border-radius: 2px;
`;

export const menuLabel = css`
  padding: 0.4rem 0 0.4rem 0.75rem;
  color: ${constants.colors.ui.neutral[500]};
`;

export const labelCss = {
  fontWeight: 700,
  color: constants.colors.ui.neutral[600],
  fontSize: "14px",
};
